module.exports = __webpack_public_path__ + "media/images/bypass-switch-77a5db0b688180c8d685163eb9cf0f90.svg";